import { render, staticRenderFns } from "./GeoDataRevision.vue?vue&type=template&id=af0d8894&"
import script from "./GeoDataRevision.vue?vue&type=script&lang=js&"
export * from "./GeoDataRevision.vue?vue&type=script&lang=js&"
import style0 from "./GeoDataRevision.vue?vue&type=style&index=0&id=af0d8894&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports